export const AddNewFileRegionValidate = (
    fileData,
    type) => {

    const errors = {}

    if (!fileData.title.trim()) {
        errors.title = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.title
    }

    if (type === "IsSuperUser") {
        if (fileData.fileConsultant == "") {
            errors.fileConsultant = "لطفا مشاور را انتخاب نمایید"
        } else {
            delete errors.fileConsultant
        }
    }

    if (fileData.region == "") {
        errors.regionName = "لطفا کشور را انتخاب کنید"
    } else {
        delete errors.regionName
    }

    if (fileData.currency == "") {
        errors.currencyName = "لطفا کشور را انتخاب کنید"
    } else {
        delete errors.currencyName
    }

    if (fileData.link == "") {
        errors.linkNumber = "لطفا link را انتخاب کنید"
    } else {
        delete errors.linkNumber
    }

    if (!fileData.startPrice) {
        errors.startPrice = "لطفا قیمت کل را وارد کنید"
    } else {
        delete errors.startPrice
    }

    if (!fileData.endPrice) {
        errors.endPrice = "لطفا قیمت هرمتر را وارد کنید"
    } else {
        delete errors.endPrice
    }

    return errors;
}